import { useState } from "react";

const DeleteConfirmation = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-lg font-semibold text-gray-800 dark:text-white">
          Are you sure?
        </h2>
        <p className="text-gray-600 dark:text-gray-300 mt-2">
          This action cannot be undone.
        </p>

        <div className="mt-4 flex justify-end gap-3">
          <button
            className="px-4 py-2 bg-gray-300 dark:bg-gray-700 text-gray-800 dark:text-white rounded-md hover:bg-gray-400 dark:hover:bg-gray-600"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
            onClick={onConfirm}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

// Usage Example
// const App = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const handleDelete = () => {
//     console.log("Item deleted!");
//     setIsModalOpen(false);
//   };

//   return (
//     <div className="p-6">
//       <button
//         className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
//         onClick={() => setIsModalOpen(true)}
//       >
//         Delete Item
//       </button>

//       <DeleteConfirmation
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         onConfirm={handleDelete}
//       />
//     </div>
//   );
// };

export default DeleteConfirmation;
